import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import DataState from '../../../Types/DataState';
import ConditionalWrap from '../../../Util/ConditionalWrap';

type PerformanceCardWrapperProps = {
  isBig: boolean;
  hmdState: string;
  children: ReactElement;
};

const PerformanceCardWrapper: React.FC<PerformanceCardWrapperProps> = ({
  isBig,
  hmdState,
  children,
}: PerformanceCardWrapperProps) => (
  <ConditionalWrap
    condition={isBig}
    wrap={(children: any) => <Column>{children}</Column>}
  >
    {hmdState === DataState.LOADING && (
      <div style={{ textAlign: 'center' }}>
        <Loader type='circular' />
      </div>
    )}
    {hmdState === DataState.LOADED && children}
    {hmdState === DataState.ERROR && (
      <Alert type='error'>
        <FormattedMessage
          id='cs_perfportal_error_reason_1'
          defaultMessage='Your credentials may be incorrect or inadequate.'
        />
      </Alert>
    )}
  </ConditionalWrap>
);

export default PerformanceCardWrapper;
